import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { articlesPart1 } from "@/mocks/articles-part1";
import { articlesPart2 } from "@/mocks/articles-part2";
import { articlesPart3 } from "@/mocks/articles-part3";

const allArticles = [...articles, ...articlesPart1, ...articlesPart2, ...articlesPart3];

export default function ArticleSection() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === "pl" || i18n.language === "es" || i18n.language === "fr" ? i18n.language : "en";

  const featured = allArticles[0];
  const featuredContent = featured.content[lang] ?? featured.content.en;
  const rest = allArticles.slice(1);

  return (
    <section id="articles" className="mx-auto max-w-7xl px-4 md:px-6 py-16">
      <div className="text-center mb-10">
        <h2 className="font-heading font-semibold text-2xl md:text-4xl text-foreground-950">{t("articles.title")}</h2>
        <p className="mt-3 text-foreground-600 max-w-2xl mx-auto">{t("articles.subtitle")}</p>
      </div>

      <Link
        to={`/article/${featured.slug}`}
        className="group flex flex-col lg:flex-row overflow-hidden rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="relative w-full lg:w-80 h-56 lg:h-auto shrink-0">
          <img
            src={featured.cover}
            alt={featuredContent.title}
            title={featuredContent.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex flex-col justify-center p-6 md:p-8">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 uppercase tracking-wider">
            <i className="ri-article-line" />
            USFans Spreadsheet
          </span>
          <h3 className="mt-3 font-heading font-semibold text-xl md:text-2xl text-foreground-950 leading-snug">{featuredContent.title}</h3>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed line-clamp-3">{featuredContent.intro}</p>
          <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 group-hover:gap-3 transition-all whitespace-nowrap">
            {t("articles.readMore")}
            <i className="ri-arrow-right-line" />
          </span>
        </div>
      </Link>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rest.map((article) => {
          const content = article.content[lang] ?? article.content.en;
          return (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-36 overflow-hidden">
                <img
                  src={article.cover}
                  alt={content.title}
                  title={content.title}
                  className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 leading-snug line-clamp-2">
                  {content.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{content.intro}</p>
                <span className="mt-auto pt-3 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 group-hover:gap-3 transition-all whitespace-nowrap">
                  {t("articles.readMore")}
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}